export default {
  logistics: {
    breadcrumbHome: 'Početna',
    breadcrumbSolutions: 'Rješenja',
    breadcrumbCurrent: 'Skladište i logistika',
    hero: {
      eyebrow: 'Skladište i logistika',
      title: 'Nadzor velikih površina za logistiku i skladišta',
      lead: 'Široki kut, PTZ i noćni vid – pokrivamo velike hale i vanjske površine s malo, ali dobro postavljenih kamera.',
    },
    areas: {
      title: 'Područja nadzora u skladištu i logistici',
      lead: 'Od ulaza do pakiranja: strukturiramo vaš nadzor duž tokova robe – tako nema praznina.',
      items: {
        '0': { title: 'Ulaz i izlaz', desc: 'Svako vozilo koje prođe vašim prostorom se bilježi – s registracijom i vremenskom oznakom za potpunu dokumentaciju.' },
        '1': { title: 'Zona dostave', desc: 'Dolazak i odvoz robe osjetljivi su trenuci. Kamere dokumentiraju svaki pokret na rampi.' },
        '2': { title: 'Regali', desc: 'Velike hale traže velika rješenja. PTZ kamere prelaze prolazima i zumiraju do palete.' },
        '3': { title: 'Komisioniranje', desc: 'Pakiranje i komisioniranje obilježeni su kretanjem. Pregledne kamere pojašnjavaju reklamacije.' },
        '4': { title: 'Vanjska površina i dvorište', desc: 'Perimetar je prva linija obrane. Kamere otporne na vremenske uvjete nadziru ograde, vrata i vozila.' },
        '5': { title: 'Ured i uprava', desc: 'I administrativno područje treba zaštitu – za vrijednosti, dokumente i osjetljive pristupe.' },
      },
    },
    coverage: {
      eyebrow: 'Velike površine pod nadzorom',
      title: 'Jedna kamera, velik učinak',
      lead: 'U skladištima je važan pregled. Umjesto mnogo pojedinačnih kamera, koristimo tehniku koja inteligentno pokriva velike površine.',
      items: {
        '0': { title: 'PTZ kamere', desc: 'Okretanje, naginjanje, zumiranje – jedna kamera pokriva velike površine i daje detalje po potrebi.' },
        '1': { title: 'Širokokutni pregled', desc: 'Za dijelove hale i vanjske prostore: kompaktne širokokutne kamere hvataju velika područja u jednoj slici.' },
        '2': { title: 'Dnevni i noćni vid', desc: 'Infracrveno i vrlo osjetljivi senzori daju upotrebljive slike i u mraku – 24 sata dnevno.' },
      },
    },
    roundClock: {
      eyebrow: 'Danonoćno',
      title: 'Snimanje koje nikad ne spava',
      lead: 'Robni promet ne staje noću. Vaš sustav snima danonoćno i relevantne događaje čini odmah dostupnima.',
      list: {
        '0': '24/7 snimanje na lokalnom snimaču s definiranim trajanjem',
        '1': 'Snimanje prema događajima štedi prostor i olakšava pretragu',
        '2': 'Prosljeđivanje alarma definiranim osobama kod kretanja u zabranjenoj zoni',
        '3': 'Redovito održavanje SSG Care za trajnu dostupnost',
        '4': 'Proširivo dodatnim kamerama i drugim lokacijama',
      },
      note: 'Napomena: trajanje pohrane treba prilagoditi poslovnim i eventualno zakonskim zahtjevima. Savjetujemo vas o tome.',
    },
    cta: {
      title: 'Vaša logistika – dokumentirana bez praznina',
      lead: 'Analiziramo tokove robe i točke rizika te planiramo sustav koji odgovara strukturi vaše hale.',
      primary: 'Zakažite termin savjetovanja',
      secondary: 'Otkrijte SSG Care',
    },
  },
};